function InputButton({ text, className, style, emit = undefined }) {
  return (
    <button
      type="submit"
      className={`cursor-pointer w-full h-[40px] flex items-center justify-center rounded-tl-[10px] rounded-br-[10px] text-sm font-bold border-2 transition duration-200 ease-in-out ${
        style == "primary"
          ? "bg-olaf-green-500 text-white border-olaf-green-500 hover:bg-transparent hover:text-olaf-green-500"
          : "bg-transparent text-olaf-green-500 border-olaf-green-500"
      } ${className}`}
      onClick={emit}
    >
      {text}
    </button>
  );
}

export default InputButton;
